import logo from "../assets/logo.png";
import React, { useState } from "react";
import Swal from "sweetalert2";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";

export const Form = () => {
  // ==========================================
  // ESTADOS DEL FORMULARIO
  // ==========================================

  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [enviando, setEnviando] = useState(false);

  // ==========================================
  // ENVIAR FORMULARIO
  // ==========================================

  const enviarContacto = async (e) => {
    e.preventDefault();
     if (enviando) return;
    setEnviando(true);

    // Alerta de carga
    Swal.fire({
      title: "Enviando mensaje...",
      text: "Por favor espera un momento.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const datos = new URLSearchParams();

      datos.append("nombre", nombre);
      datos.append("correo", correo);
      datos.append("mensaje", mensaje);

      const respuesta = await fetch(
        "https://teenmissionsperu.org/api/guardar-contacto.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: datos.toString(),
        }
      );

      const resultado = await respuesta.json();

      if (resultado.success) {
        Swal.fire({
          icon: "success",
          title: "¡Mensaje enviado!",
          text: "Gracias por comunicarte con Teen Missions Perú. Hemos recibido tu consulta.",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#9b2a92",
        });

        // Limpiar formulario
        setNombre("");
        setCorreo("");
        setMensaje("");
      } else {
        Swal.fire({
          icon: "error",
          title: "No se pudo enviar",
          text:
            resultado.mensaje ||
            "Ocurrió un problema al enviar tu mensaje.",
          confirmButtonText: "Intentar nuevamente",
          confirmButtonColor: "#9b2a92",
        });
      }
    } catch (error) {
      console.error("Error al enviar:", error);

      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No pudimos enviar tu mensaje. Verifica tu conexión e inténtalo nuevamente.",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#9b2a92",
      });
    } finally {
      setEnviando(false);
    }
  };

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <section id="contacto" className="banner-section">
      {/* Círculo */}
      <div className="logo-circle">
        <img src={logo} alt="Teen Missions Perú" />
      </div>

      {/* Curva */}
      <svg
        className="banner-wave"
        viewBox="0 0 1920 500"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="footerGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#44296a" />
            <stop offset="100%" stopColor="#370a33" />
          </linearGradient>
        </defs>

        <path
          d="
            M0,0
            C350,15 750,80 1100,170
            C1450,255 1680,300 1920,315
            L1920,500
            L0,500
            Z
          "
        />
      </svg>

      <div
        className="container position-relative"
        style={{ zIndex: 10 }}
      >
        <div className="row g-5 align-items-start">

          {/* ================================
              REDES SOCIALES
          ================================= */}

          <div className="col-lg-5 bajar-col">
            <h2 className="fw mb-4">Redes Sociales</h2>

            <div className="d-flex gap-3 mt-4">

              <a
                href="https://www.facebook.com/TMIP1/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link text-white"
              >
                <FaFacebook />
              </a>

              <a
                href="https://www.instagram.com/teenmissionsperu/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link text-white"
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.youtube.com/@teenmissionsperu"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link text-white"
              >
                <FaYoutube />
              </a>

              <a
                href="https://www.tiktok.com/@teenmissionsperu"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link text-white"
              >
                <FaTiktok />
              </a>

              <a
                href="https://wa.me/51987706440"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link text-white"
              >
                <FaWhatsapp />
              </a>

            </div>
          </div>

          {/* ================================
              INFORMACIÓN DE CONTACTO
          ================================= */}

          <div className="col-lg-4">
            <h3 className="fw mb-5">
              Información de Contacto
            </h3>

            <div className="mb-5">
              <h6 className="fw fs-4">
                <FaMapMarkerAlt className="me-2" />
                Ubicación
              </h6>

              <p className="mb-0 fs-5">
                Perú - Ucayali - Pucallpa
              </p>
            </div>

            <div className="mb-5">
              <h6 className="fw fs-4">
                <FaWhatsapp className="me-2" />
                WhatsApp
              </h6>

              <p className="mb-0 fs-5">
                +51 987706440
              </p>
            </div>

            <div>
              <h6 className="fw fs-4">
                <FaEnvelope className="me-2" />
                Correo
              </h6>

              <p className="mb-0 fs-5">
                contacto@teenmissionsperu.org
              </p>
            </div>
          </div>

          {/* ================================
              FORMULARIO DE CONTACTO
          ================================= */}

          <div className="col-lg-3">
            <div className="glass-card">

              <h4 className="fw mb-3">
                Contáctanos
              </h4>

              <form onSubmit={enviarContacto}>

                {/* Nombre */}
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Nombre"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                />

                {/* Correo */}
                <input
                  type="email"
                  className="form-control mb-3"
                  placeholder="Correo electrónico"
                  value={correo}
                  onChange={(e) => setCorreo(e.target.value)}
                  required
                />

                {/* Mensaje */}
                <textarea
                  className="form-control mb-3"
                  placeholder="Escribe tu mensaje o consultas..."
                  rows="4"
                  value={mensaje}
                  onChange={(e) => setMensaje(e.target.value)}
                  required
                />

                {/* Botón */}
                <button
                  type="submit"
                  className="btn btn-subscribe w-100"
                  disabled={enviando}
                >
                  {enviando
                    ? "Enviando..."
                    : "Enviar mensaje"}
                </button>

              </form>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};